import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

import Header from './components/Header';
import Footer from './components/Footer';

import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Howitworks from './pages/Howitworks';
import Contact from './pages/Contact';
import Booking from './pages/Booking';
import Profile from './pages/Profile';
import TermsAndConditions from './pages/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ShippingDeliveryPolicy from './pages/ShippingDeliveryPolicy';
import RefundReturnPolicy from './pages/RefundReturnPolicy';
import CancellationReplacementPolicy from './pages/CancellationReplacementPolicy';
import DisputeResolutionPolicy from './pages/DisputeResolutionPolicy';
import GoverningLawJurisdiction from './pages/GoverningLawJurisdiction';
import AcceptanceOfTerms from './pages/AcceptanceOfTerms';
import PaymentMethod from './pages/PaymentMethod';
import Faqs from './pages/Faqs';
import DamagePolicy from './pages/DamagePolicy';

import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AccountsDashboard from './pages/accounts/AccountsDashboard'; // 👈 Accounts Component Import ചെയ്തു

import './App.css';

function AppContent() {
  const location = useLocation();

  // /admin, /admin-login, /admin-dashboard തുടങ്ങിയ എല്ലാ അഡ്മിൻ പേജുകളിലും Header, Footer മറയ്ക്കാൻ
  const isAdminPage = location.pathname.startsWith('/admin') || location.pathname === '/admin-login' || location.pathname === '/admin-dashboard';

  return (
    <div className="App">
      {!isAdminPage && <Header />}

      <main>
        <Routes>
          {/* Main Pages */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/howitworks" element={<Howitworks />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/profile" element={<Profile />} />

          {/* Policy Pages */}
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/shipping-delivery-policy" element={<ShippingDeliveryPolicy />} />
          <Route path="/refund-return-policy" element={<RefundReturnPolicy />} />
          <Route path="/cancellation-replacement-policy" element={<CancellationReplacementPolicy />} />
          <Route path="/dispute-resolution-policy" element={<DisputeResolutionPolicy />} />
          <Route path="/governing-law-jurisdiction" element={<GoverningLawJurisdiction />} />
          <Route path="/acceptance-of-terms" element={<AcceptanceOfTerms />} />
          <Route path="/payment-methods" element={<PaymentMethod />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/damage-policy" element={<DamagePolicy />} />

          {/* Admin Pages */}
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route path="/admin-dashboard" element={<AdminDashboard />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          
          {/* 🎯 Accounts Dedicated Route */}
          <Route path="/admin/accounts" element={<AccountsDashboard />} />
        </Routes>
      </main>

      {!isAdminPage && <Footer />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;